import { cn } from '../../lib/utils';
import { formatNumber } from '../../constants/nginx-sites';
import { NginxSiteSummary } from '../../types';

interface SiteTabsProps {
  sites: NginxSiteSummary[];
  selectedSiteId: number | null;
  onSelectSite: (siteId: number) => void;
}

export function SiteTabs({ sites, selectedSiteId, onSelectSite }: SiteTabsProps) {
  return (
    <div className="overflow-x-auto">
      <div className="flex gap-2 min-w-max pb-1">
        {sites.map((site) => {
          const isActive = site.siteId === selectedSiteId;
          return (
            <button
              key={site.siteId}
              onClick={() => onSelectSite(site.siteId)}
              className={cn(
                'flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all border-b-2 whitespace-nowrap',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary',
                isActive
                  ? 'border-b-2 text-foreground'
                  : 'border-b-2 border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
              )}
              style={
                isActive
                  ? {
                      borderBottomColor: site.color,
                      backgroundColor: `${site.color}1a`,
                    }
                  : undefined
              }
              onMouseEnter={(e) => {
                if (!isActive) {
                  (e.currentTarget as HTMLButtonElement).style.borderBottomColor = site.color;
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  (e.currentTarget as HTMLButtonElement).style.borderBottomColor = 'transparent';
                }
              }}
            >
              <span
                className="w-2.5 h-2.5 rounded-full shrink-0"
                style={{ backgroundColor: site.color }}
              />
              <div className="flex flex-col items-start">
                <span>{site.name}</span>
                <span className="text-xs text-muted-foreground font-normal leading-none mt-0.5">
                  {formatNumber(site.visitors)} vis.
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
